import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { HUNTR_TESTIMONIALS as T } from '@/data/huntr';

export default function HuntrTestimonials() {
  const [i, setI] = useState(0);
  const go = (d) => setI((v) => (v + d + T.length) % T.length);

  useEffect(() => {
    const t = setTimeout(() => go(1), 7000);
    return () => clearTimeout(t);
  }, [i]);

  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-10 text-center">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Client Results</p>
        <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight leading-tight">
          Trusted by teams who needed replies, not reports.
        </h2>

        <div className="relative mt-12 rounded-2xl border border-white/10 bg-white/[0.03] px-6 sm:px-14 py-12 min-h-[320px] flex flex-col items-center justify-center">
          <Quote className="w-8 h-8 text-[#3B82F6]/60" />
          <AnimatePresence mode="wait">
            <motion.figure key={i} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} transition={{ duration: 0.4 }}>
              <blockquote className="mt-6 text-white/85 text-lg lg:text-xl font-light leading-relaxed">“{T[i].quote}”</blockquote>
              <figcaption className="mt-7 flex flex-col items-center gap-2">
                <span className="flex gap-1">
                  {[0, 1, 2, 3, 4].map((s) => <Star key={s} className="w-3.5 h-3.5 fill-[#3B82F6] text-[#3B82F6]" />)}
                </span>
                <span className="font-display font-semibold text-white">{T[i].name}</span>
                <span className="text-[11px] uppercase tracking-[0.16em] text-white/40">Huntr Client</span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>

          <button onClick={() => go(-1)} aria-label="Previous testimonial" className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full border border-white/15 text-white/70 hover:border-[#3B82F6] hover:text-white flex items-center justify-center transition-colors">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={() => go(1)} aria-label="Next testimonial" className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full border border-white/15 text-white/70 hover:border-[#3B82F6] hover:text-white flex items-center justify-center transition-colors">
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {T.map((t, n) => (
            <button key={t.name} onClick={() => setI(n)} aria-label={`Show testimonial ${n + 1}`} className={`h-1.5 rounded-full transition-all duration-300 ${n === i ? 'w-8 bg-[#3B82F6]' : 'w-3 bg-white/20'}`} />
          ))}
        </div>
      </div>
    </section>
  );
}